import React from "react";

export const CatholicBook = ({size = 20, ...props}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width={size}
            height={size}
            {...props}
        >
            <path
                d="M16 1h36a2 2 0 012 2v47a1 1 0 01-1 1H11a1 1 0 01-1-1V7a6 6 0 016-6z"
                fill="#6b645c"
            />
            <path d="M12 8v43h41a1 1 0 001-1V3H17a5 5 0 00-5 5z" fill="#5c564f" />
            <path d="M11 51h42v3l-1 1 1 1v3H17a6 6 0 01-6-6z" fill="#e7edf3" />
            <path
                d="M53 56H15a5.006 5.006 0 01-5-5h2a3.003 3.003 0 003 3h38z"
                fill="#dbe0e8"
            />
            <path
                d="M12 53v-1h41a1 1 0 001-1v-1H10v3a7 7 0 007 7h36a1 1 0 001-1 1 1 0 00-1-1H17a5 5 0 01-5-5z"
                fill="#6b645c"
            />
            <path
                d="M24 17h5v-5a3 3 0 016 0v5h5a3 3 0 010 6h-5v17a3 3 0 01-6 0V23h-5a3 3 0 010-6z"
                fill="#fad356"
            />
            <path d="M38 56v7l4-4 4 4v-7z" fill="#dc4f2d" />
        </svg>
    );
}